import * as HttpService from './HttpService'

let namespace = '/invoices'

const find = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

const all = (params, cb, errorCb) => {
    HttpService.get('all-invoices', params, cb, errorCb)
}

const unpaid = (params, cb, errorCb) => {
    HttpService.get('unpaid-invoices', params, cb, errorCb)
}

const between = (dateFrom, dateTo, department, params, cb, errorCb) => {
    params = {
        ...params,
        ...{'filter[between]': dateFrom + ',' + dateTo},
        ...{'per_page': 50}
    }
    if (department.uuid) {
        params = {...params, ...{'filter[department]': department.name}}
    }
    HttpService.get(namespace, params, cb, errorCb)
}

export {
    find,
    all,
    unpaid,
    between
}



// WEBPACK FOOTER //
// ./src/services/invoiceService.js